<template>
  <div class="container_wrap">
    <div class="layout_main layout">
      <Breadcrumbs :title="computedTitle"></Breadcrumbs>
      <div class="wzlb_one Multiline">
        <div class="main_body">
          <div class="list">
            <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
              <a class="item_left"
                href="https://mp.weixin.qq.com/s?__biz=MzkxMDM3NTMzMA==&amp;mid=2247501796&amp;idx=3&amp;sn=f1e533ddc5750a8b1c6a1d6b2a5836d0&amp;chksm=c013048214d80db04888e96d2ef61a103f3356628ecb04058f1248144cb5f6fbae44f563db0b&amp;mpshare=1&amp;scene=1&amp;srcid=10092Tlk1LjivmXbSkiZEbIQ&amp;sharer_shareinfo=a29abf1e71f46051134eab3c408964c9&amp;sharer_shareinfo_first=a29abf1e71f46051134eab3c408964c9&amp;from=industrynews&amp;version=4.1.30.6008&amp;platform=win&amp;nwr_flag=1&amp;poc_token=HEsbH2ejMQKLVWFZj8FAajjBhfSjxwjizfloczVQ"
                target="_blank" title="人力资源和社会保障部门“家庭教育指导”招生简章" style="width:90%;">
                <div class="item_title ">人力资源和社会保障部门“家庭教育指导”招生简章</div>
                <div class="item_time" title="h/spec/sxjtjy/jchd">2024-06-04</div>
              </a>
            </div>
            <div class="item has_theme hover_theme color_1577FE color_1577FE_hover">
              <a class="item_left"
                href="https://mp.weixin.qq.com/s?__biz=MzkxMDM3NTMzMA==&amp;mid=2247501704&amp;idx=1&amp;sn=b23f6284d743f35a2300e2caf4f33bed&amp;chksm=c0b43c210cf4741370b7fda927faad613be0f7255e6da1e095b5a5d1f52c3d0309b8000d52eb&amp;mpshare=1&amp;scene=1&amp;srcid=1009ow2CegLlLh1pU4gLbxmE&amp;sharer_shareinfo=439c48998800ed575c315dc36d974026&amp;sharer_shareinfo_first=439c48998800ed575c315dc36d974026&amp;from=industrynews&amp;version=4.1.30.6008&amp;platform=win&amp;nwr_flag=1#wechat_redirect"
                target="_blank" title="人社部 “家庭教育指导专项职业能力” 证书详解" style="width:90%;">
                <div class="item_title ">人社部 “家庭教育指导专项职业能力” 证书详解</div>
                <div class="item_time" title="h/spec/sxjtjy/jchd">2024-05-24</div>
              </a>
            </div>
          </div>
          <div class="digg"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from './component/breadcrumb.vue';

export default {
  name: 'NetworkingIndex',
  components: {
    Breadcrumbs
  },
  data() {
    return {
       type: this.$route.params.type,
      items: [
        { title: '山西省第三届家庭教育指导技能大赛', link: 'https://org.ttcdw.cn/project/983123849693712384' },
        { title: '山西省第二届家庭教育指导技能大赛', link: 'https://org.ttcdw.cn/project/903439760222658560' }
      ]
    };
  },
  computed: {
    // 根据 type 动态计算标题
    computedTitle() {
      const titleMap = {
        0: '家庭教育专项证书',
        1: '心理健康专项证书',
        2: '三家教育论坛',
        3: '优秀讲师评选',
        4: '大赛通知',
        5: '培训动态',
        6: '政策文件'

      };
      return titleMap[this.type];
    }
  },
  mounted() {
    document.title = '山西省第三届家庭教育指导技能大赛';
  }
};

</script>

<style lang="scss" scoped>
.container_wrap {
  width: 100%;
  min-width: 1200px;
  overflow: hidden;
  padding-bottom: 306px;

  .layout_main {
    padding: 20px 0 30px 0;

    .wzlb_one {
      .main_body {
        padding-top: 30px;
        padding-bottom: 15px;



        .list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;



          .item {
            position: relative;
            width: 100%;
            box-sizing: border-box;
            color: #505050;
            font-size: 18px;
            font-weight: 400;
            height: 36px;
            line-height: 36px;
            margin-bottom: 30px;

            .item_left {
              width: 100%;
              display: block;
              height: 36px;
              float: left;
              /*display: flex;*/
            }
          }

          .item_icon {
            float: left;
            width: 32px;
            height: 36px;
            line-height: 36px;

            .icon {
              font-size: 20px;
              width: 1em;
              height: 36px;
              vertical-align: -1px;
              fill: currentColor;
              overflow: hidden;
            }

            img {
              display: block;
            }
          }

          .item_title {
            float: left;
            color: #333333;
            font-size: 16px;
            font-weight: 400;
            line-height: 36px;
            width: 75%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;
          }

          .item_name {
            float: right;
            color: #333333;
            font-size: 14px;
            font-weight: 400;
            line-height: 36px;
            margin-left: 10px;
          }

          .item_download {
            float: right;
            color: #999;
            font-size: 14px;
            font-weight: 400;
            line-height: 36px;
            margin-left: 10px;
          }

          .item_time {
            float: right;
            color: #999;
            font-size: 14px;
            font-weight: 400;
            line-height: 36px;
            margin-left: 10px;
          }

          .item_title:hover {
            color: #1577fe !important;
          }
        }
      }


    }
  }

  .layout {
    width: 1200px;
    margin: 0 auto;
  }
}
</style>
